import { render, staticRenderFns } from "./base-form.vue?vue&type=template&id=cc86d4f4"
import script from "./base-form.ts?vue&type=script&lang=ts&external"
export * from "./base-form.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/foex-3r/foex-3r-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('cc86d4f4')) {
      api.createRecord('cc86d4f4', component.options)
    } else {
      api.reload('cc86d4f4', component.options)
    }
    module.hot.accept("./base-form.vue?vue&type=template&id=cc86d4f4", function () {
      api.rerender('cc86d4f4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/vuetify/Form/base-form.vue"
export default component.exports